import cx from 'classnames';
import React, { ReactElement, ReactNode } from 'react';

/**
 * Smoothly expands/collapses its children by transitioning height (and opacity) whenever `show`
 * changes, so surrounding content slides instead of jumping. Uses the grid `0fr <-> 1fr` trick,
 * the only CSS-only way to animate to/from an auto height. Content stays mounted while collapsed.
 * Transitions never fire on the initial render, so the first paint reflects `show` instantly.
 */
export const CollapseIn = ({
  show = true,
  children,
  className,
}: {
  show?: boolean;
  children: ReactNode;
  className?: string;
}): ReactElement => (
  <div
    aria-hidden={!show}
    className={cx(
      'grid transition-[grid-template-rows,opacity] duration-300 ease-out',
      show ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0',
      className,
    )}
  >
    {/* `-mx-1 px-1`: `overflow-hidden` clips a focused field's ring off flat, and cannot be flipped mid-transition. */}
    <div className="-mx-1 overflow-hidden px-1">{children}</div>
  </div>
);

export default CollapseIn;
